import { isShareView } from "../share/shareView";
// "/pure": the plain import loads Stripe.js the moment it is imported, on EVERY page; a shared replay clip's page must contact no one else (Stripe's frame is told the page address, which holds the link's secret)
import { loadStripe } from "@stripe/stripe-js/pure";

import config from "../config/config";

// Centralizes what used to be FOUR separate copies of the same bug
// (Payment.tsx, Settings.tsx, CreditPurchaseModal.tsx, InfoModel.tsx,
// InformationModel.tsx - five, actually), found and fixed 2026-08-14:
// each one called loadStripe() directly inside its own component body,
// so every re-render created a brand new Stripe instance and handed it to
// <Elements stripe={...}>. react-stripe-js silently ignores the `stripe`
// prop changing after the first render - it doesn't throw, doesn't error
// visibly, it just keeps using whatever was passed the first time. The
// practical effect, confirmed live: a payment submit button can end up
// permanently disabled (PaymentModal.tsx gates it on `!stripe` from
// useStripe()) with zero console output and zero network activity when
// useStripe() never resolves against a still-valid Elements context -
// which happened after ANY unrelated re-render (a Redux LOGIN action from
// something as ordinary as a periodic account-record refresh was enough).
//
// A single module-level constant, computed once at import time, is what
// every one of Stripe's own docs/examples actually shows - the bug was
// never "forgot to memoize," it was "never had a single source of truth
// to memoize from" across five near-identical copies. Every file that
// needs an <Elements stripe={...}> provider should import this, not call
// loadStripe() itself.
// DEMO BUILD ONLY (REACT_APP_DEMO=1): no payment script is ever loaded (and the build carries no Stripe key). Removed from normal builds at build time.
const stripePromise = process.env.REACT_APP_DEMO === "1" || isShareView() ? Promise.resolve(null) : loadStripe(config.stripePublishableKey as string);

export default stripePromise;
